var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: false } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-3 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.tipoPoblacionBeneficiada"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.tipoPoblacionBeneficiada"
                            ),
                            description: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.tipoPoblacionBeneficiadaDesc"
                            ),
                            "label-for": "form-tipo-poblacion-beneficiada",
                          },
                        },
                        [
                          _c("b-form-checkbox-group", {
                            attrs: {
                              name: "form-tipo-poblacion-beneficiada",
                              switch: "",
                              options: _vm.opcionesTipoPoblacionBeneficiada,
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.poblacionForm.poblacionesBeneficiarias,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "poblacionesBeneficiarias",
                                  $$v
                                )
                              },
                              expression:
                                "poblacionForm.poblacionesBeneficiarias",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.numeroPersonasBeneficiadas"
                              ) + ":",
                            "label-for": "form-numero-personas-beneficiadas",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-numero-personas-beneficiadas",
                              type: "number",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.poblacionForm.personasBeneficiadas,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "personasBeneficiadas",
                                  $$v
                                )
                              },
                              expression: "poblacionForm.personasBeneficiadas",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm.personasBeneficiadas.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-3 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.beneficiariosDirectos"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.mujeres"
                              ) + ":",
                            "label-for": "form-mujeres-beneficiadas",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-mujeres-beneficiadas",
                              type: "number",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.poblacionForm.mujeresBeneficiadas,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "mujeresBeneficiadas",
                                  _vm._n($$v)
                                )
                              },
                              expression: "poblacionForm.mujeresBeneficiadas",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm.mujeresBeneficiadas.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.hombres"
                              ) + ":",
                            "label-for": "form-hombres-beneficiados",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-hombres-beneficiados",
                              type: "number",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.poblacionForm.hombresBeneficiados,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "hombresBeneficiados",
                                  _vm._n($$v)
                                )
                              },
                              expression: "poblacionForm.hombresBeneficiados",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm.hombresBeneficiados.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.otros"
                              ) + ":",
                            "label-for": "form-otros-beneficiados",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-otros-beneficiados",
                              type: "number",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.poblacionForm.otrosBeneficiados,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "otrosBeneficiados",
                                  _vm._n($$v)
                                )
                              },
                              expression: "poblacionForm.otrosBeneficiados",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm.otrosBeneficiados.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.total"
                              ) + ":",
                            "label-for": "form-total-beneficiados",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-total-beneficiados",
                              type: "number",
                              disabled: "",
                            },
                            model: {
                              value: _vm.totalBeneficiados,
                              callback: function ($$v) {
                                _vm.totalBeneficiados = $$v
                              },
                              expression: "totalBeneficiados",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.caracteristicaPoblacionBeneficiada"
                            ),
                            "label-for": "form-caracteristica-poblacion",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-caracteristica-poblacion",
                              rows: "4",
                            },
                            model: {
                              value:
                                _vm.poblacionForm
                                  .caracteristicasPoblacionBeneficiada,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.poblacionForm,
                                  "caracteristicasPoblacionBeneficiada",
                                  $$v
                                )
                              },
                              expression:
                                "poblacionForm.caracteristicasPoblacionBeneficiada",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm
                            .caracteristicasPoblacionBeneficiada.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.poblacionForm
                            .caracteristicasPoblacionBeneficiada.maxLength
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.maxlength", {
                                      max: 500,
                                    })
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _vm.esEscritura
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            attrs: {
                              type: "button",
                              disabled: _vm.desactivarBoton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.guardarPoblacion()
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                  )
                                ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }